import React, { useState } from 'react';
import {
    Card,
    Form,
    Select,
    Button,
    message,
    Table,
    Alert,
    Typography,
} from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import UserSelect from '../../components/UserSelect';
import quotaService from '../../services/quotaService';

const { Paragraph } = Typography;

// 后端 QuotaService::recalculateUsage 目前仅支持这三类账号级别配额重算
const PRODUCT_TYPES = [
    { value: 'cdn', label: 'CDN（加速域名）' },
    { value: 'dns', label: 'DNS（托管区域）' },
    { value: 'domain', label: '域名（已注册域名）' },
];

const Quotas = () => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [stats, setStats] = useState(null);

    const handleRecalculate = async (values) => {
        setSubmitting(true);
        setStats(null);
        try {
            const response = await quotaService.recalculate(values.user_id, values.product_type);
            if (response.success) {
                message.success('配额使用量已重算');
                setStats(response.stats || {});
            } else {
                message.error(response.error || '重算失败');
            }
        } catch (error) {
            message.error('重算失败：' + (error.error || error.message));
        } finally {
            setSubmitting(false);
        }
    };

    const statsRows = stats
        ? Object.keys(stats).map((key) => ({ key, feature: key, value: stats[key] }))
        : [];

    return (
        <Card title="配额管理 · 使用量重算">
            <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message="按真实资源数量重算指定用户的账号级别配额使用量"
                description="当资源计数与配额使用量出现偏差时，可在此按用户 + 产品类型重新统计并写回。目前支持 CDN / DNS / 域名 三类。"
            />
            <Form
                form={form}
                layout="inline"
                onFinish={handleRecalculate}
                style={{ marginBottom: 16 }}
            >
                <Form.Item
                    name="user_id"
                    label="用户"
                    rules={[{ required: true, message: '请选择用户' }]}
                >
                    <UserSelect style={{ width: 240 }} />
                </Form.Item>
                <Form.Item
                    name="product_type"
                    label="产品类型"
                    rules={[{ required: true, message: '请选择产品类型' }]}
                >
                    <Select
                        style={{ width: 220 }}
                        placeholder="选择产品类型"
                        options={PRODUCT_TYPES}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SyncOutlined />}
                        loading={submitting}
                    >
                        重算使用量
                    </Button>
                </Form.Item>
            </Form>

            {stats && (
                statsRows.length > 0 ? (
                    <Table
                        size="small"
                        pagination={false}
                        rowKey="key"
                        dataSource={statsRows}
                        columns={[
                            { title: '配额项', dataIndex: 'feature', key: 'feature' },
                            { title: '重算后使用量', dataIndex: 'value', key: 'value', align: 'right' },
                        ]}
                    />
                ) : (
                    <Paragraph type="secondary">该产品类型没有可重算的账号级别配额。</Paragraph>
                )
            )}
        </Card>
    );
};

export default Quotas;
